import { Action } from "@ngrx/store";
import { ReduxAction } from "./../actions/redux.action";
import { PatientTestResultsModel } from '../models/patient-test-results.model';

export function PatientTestResultsReducer(state: PatientTestResultsModel, action: ReduxAction) {
  switch (action.type) {
    case "SET_PATIENT_TEST_RESULTS_INFO":
      return Object.assign({}, state, action.get());

    case "CLEAR_PATIENT_TEST_RESULTS":
    case "LOGOUT":
      return null;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reducers/patient-test-results.reducer.ts